import * as React from 'react';
import styles from './icons.scss';
import classnames from 'classnames';

type Props = React.SVGProps<SVGSVGElement> & {
    locked: boolean,
}
function AccessCodeIcon({ locked, ...props }: Props) {
  return (
    <React.Fragment>
      {locked && (
        <svg
          {...props}
          width="1em"
          height="1em"
          viewBox="0 0 32 32"
          fill="currentColor"
          className={classnames(styles.icons, props.className)}
        >
          <path
            d="M11 15.5V12a4 4 0 014-4v0a4 4 0 014 4v3.5M15 22.5v-2M14.5 20a.5.5 0 01.5-.5.5.5 0 01.5.5.5.5 0 01-1 0z" />
          <path
            d="M8.5 15.5h13v11h-13v-11zM19.53 7l1.9 2.05 4.51-4.1" />
        </svg>
      )}
      {!locked && (
        <svg
          {...props}
          width="1em"
          height="1em"
          viewBox="0 0 32 32"
          fill="currentColor"
          className={classnames(styles.icons, props.className)}
        >
          <path
            d="M8.5 15.5h13v11h-13v-11zM19 15.5V12a4 4 0 00-7.465-2M15 22.5v-2" />
          <path
            d="M14.5 20a.5.5 0 01.5-.5.5.5 0 01.5.5.5.5 0 01-1 0zM25.43 8h-5M22.94 10.51v-5" />
        </svg>
      )}
    </React.Fragment>
  );
}
export default React.memo(AccessCodeIcon);
